import typography from '../typography';
import palette from '../palette';
export default {
  root: {
    fontSize: typography.h5.fontSize,
    color: palette.text.inputLabel,
  },
};
